import { useState } from "react";
import { Box, Button } from "@mui/material";
import ModuleHeader from "../../../components/ModuleHeader";
import { useNavigate } from "react-router-dom";
import TaskSplitView from "./components/TaskSplitView";
import AddTaskDialog from "./components/AddTaskDialog";
import { TASKS as INITIAL_TASKS } from "../../../data";
import "./tasks.css";

export default function ClientTasksDashboard() {
  const navigate = useNavigate();
  const [tasks, setTasks] = useState(INITIAL_TASKS);
  const [dialogOpen, setDialogOpen] = useState(false);

  const handleAddTask = (newTask) => {
    setTasks((prev) => [...prev, newTask]);
  };

  return (
    <Box sx={{ p: 3 }}>
      <ModuleHeader
        title="Tasks"
        subtitle="Manage and track all workspace tasks"
        actions={
          <Button
            variant="contained"
            onClick={() => setDialogOpen(true)}
          >
            + Add Task
          </Button>
        }
      />

      <TaskSplitView tasks={tasks} />

      <AddTaskDialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        onSave={handleAddTask}
      />
    </Box>
  );
}
